/*
 * QuotationsConstants
 */

export const GET_QUOTATIONS = 'ideal/Quotations/GET_QUOTATIONS';
export const SEARCH_QUOTATIONS = 'ideal/Quotations/SEARCH_QUOTATIONS';
export const QUOTATIONS_RECEIVED = 'ideal/Quotations/QUOTATIONS_RECEIVED';

export const LOAD_FILTERS = 'ideal/Quotations/LOAD_FILTERS';
export const FILTERS_RECEIVED = 'ideal/Quotations/FILTERS_RECEIVED';
export const UPDATE_SORT = 'ideal/Quotations/UPDATE_SORT';

export const REMOVE_ALL = 'ideal/Quotations/REMOVE_ALL';
export const REMOVE_FILTER = 'ideal/Quotations/REMOVE_FILTER';

export const SET_PAGE_NUMBER = 'ideal/Quotations/SET_PAGE_NUMBER';

export const DOWNLOAD_QUOTATIONS = 'ideal/Quotations/DOWNLOAD_QUOTATIONS';

export const SET_LOADING = 'ideal/Quotations/SET_LOADING';

